import * as Yup from "yup";

const ProfileFormValidation = Yup.object().shape({
 //  firstName: Yup.string().required("First name is required"),
 //  lastName: Yup.string().required("Last name is required"),
 firstName: Yup.string()
  .required("First name is required!")
  .test(
   "no-empty-blank-space",
   "First name cannot be an empty blank space(s)",
   (value: any) => {
    return value && value.trim() !== "";
   }
  ),
 lastName: Yup.string()
  .required("Last name is required!")
  .test(
   "no-empty-blank-space",
   "Last name cannot be an empty blank space(s)",
   (value: any) => {
    return value && value.trim() !== "";
   }
  ),
});

export default ProfileFormValidation;
